
    <div class="value">{{ (value.amount | translate) || 'N/A' }}</div>
    <div class="label">{{ value.reviewer && 'By ' + value.reviewer }}</div>
  